export enum PriseCommandeEnum {
  PORTAIL = 'PORTAIL',
  PORTAGE = 'PORTAGE'
}
